module.exports = __webpack_public_path__ + "img/21.9416be22.png";